import React from 'react';
import { Users, Flame, Utensils } from 'lucide-react';
export function About() {
  const benefits = [{
    icon: <Users className="text-[#D2691E]" size={32} data-id="element-17" data-mp="2psi6v0c0klq8" />,
    title: 'Elite Networking',
    description: 'Connect with 50+ ecommerce finance leaders in a relaxed, authentic setting.'
  }, {
    icon: <Flame className="text-[#D2691E]" size={32} data-id="element-18" data-mp="2ysy9k7kxnou1" />,
    title: 'Strategic Workshops',
    description: 'Hands-on tool demos and workshops focused on scaling and financial operations.'
  }, {
    icon: <Utensils className="text-[#D2691E]" size={32} data-id="element-19" data-mp="38oi5uv3espjb" />,
    title: 'Legendary BBQ',
    description: 'Exclusive private dinner at Franklin Barbecue - skip the line for the best brisket in Texas.'
  }];
  return <section id="about" className="py-24 bg-[#FFF8DC]" data-id="element-20" data-mp="3mhrbqls5esx3">
      <div className="container mx-auto px-4 md:px-6" data-id="element-21" data-mp="3mjaqg7y5ovwr">
        <div className="text-center mb-16" data-id="element-22" data-mp="3rgaxal2ty2ox">
          <h2 className="text-4xl md:text-5xl font-bold text-[#2F1B10] font-serif mb-4" style={{
          fontFamily: 'Rockwell, "Courier New", serif'
        }} data-id="element-23" data-mp="3rhc6sl476h4j">
            About The Event
          </h2>
          <div className="w-32 h-1 bg-[#D2691E] mx-auto rounded-full" data-id="element-24" data-mp="2cq9e3n3rtwju"></div>
        </div>

        <div className="max-w-4xl mx-auto text-center mb-20" data-id="element-25" data-mp="27rfzfrcqzzi3">
          <p className="text-sm uppercase tracking-widest text-[#D2691E] font-bold mb-4" data-id="element-26" data-mp="27tait18dfjk2">
            Brought to you by ECOM CFO & ECOM CPA
          </p>
          <p className="text-xl text-[#556B2F] leading-relaxed font-medium" data-id="element-27" data-mp="30flkkf7prqig">
            ECOM CFO and ECOM CPA are teaming up to bring the Commerce CFO
            Roundtable to Austin for a unique blend of professional development
            and Texas culture. Join us in East Austin for two days of high-level
            strategy discussions, followed by an unforgettable evening at
            America's most celebrated barbecue joint.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-10" data-id="element-28" data-mp="3jd4wprpgxp93">
          {benefits.map((benefit, index) => <div key={index} className="bg-white p-10 rounded-xl shadow-xl border-t-4 border-[#D2691E] hover:transform hover:-translate-y-2 transition-all duration-300" data-id="element-29" data-mp="b4ng4o5d6vnh" data-mpi={index}>
              <div className="mb-6 bg-[#FFF8DC] w-16 h-16 rounded-full flex items-center justify-center mx-auto" data-id="element-30" data-mp="1elnrk5zar2r">
                {benefit.icon}
              </div>
              <h3 className="text-2xl font-bold mb-4 text-[#8B4513] text-center font-serif" data-id="element-31" data-mp="3jn33f0eriilp">
                {benefit.title}
              </h3>
              <p className="text-[#556B2F] text-center leading-relaxed" data-id="element-32" data-mp="3aktuug320zay">
                {benefit.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}